import { render, staticRenderFns } from "./PageSignUpComplete.vue?vue&type=template&id=3c815649"
import script from "./PageSignUpComplete.vue?vue&type=script&lang=js"
export * from "./PageSignUpComplete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports